export const NOTES = "Notes";
export const QUESTIONS = "Questions";
export const SAVE = "Save";
export const CANCEL = "Cancel";